import React from "react";
import values from "../../../../../../values";
import Context from "../../../../../../context";

import { IItem } from "../../../../../../types/common.interface";
import { useFormik } from "formik";
import { ICreateStudent } from "../../../../../../types/student.interface";
import {
  CustomButton2,
  CustomCheckBox,
  CustomDropdownSearch,
  CustomInput,
  CustomTimePiker,
  CustomView,
  ImageUploader,
} from "../../../../../../components";

import * as Yup from "yup";
import validations from "../../../../../../validations";
import { ISchoolGrade } from "../../../../../../types/school.interface";

type Props = {
  onBack: (event: ICreateStudent) => void;
  onSubmit: (event: ICreateStudent) => void;
  defaultValues: ICreateStudent;
};

const StudentInformation = (props: Props) => {
  const { isLoading, uploadImage } = React.useContext(Context.ServiceScreen);
  const [selectedGrade, setSelectedGrade] = React.useState<IItem | undefined>(
    props?.defaultValues?.grade
  );
  const [selectedField, setSelectedField] = React.useState<IItem | undefined>(
    props?.defaultValues?.field
  );
  const [selectedGender, setSelectedGender] = React.useState<IItem | undefined>(
    props?.defaultValues?.gender
  );
  const [selectedBirthDate, setSelectedBirthDate] = React.useState<
    string | undefined
  >(props?.defaultValues?.birthDate);
  const [selectedImage, setSelectedImage] = React.useState<string>();
  const [disability, setDisability] = React.useState<
    "SEEING" | "HEARING" | "MOBILITY" | "OTHER" | "NONE" | undefined
  >(
    props?.defaultValues?.disability ? props?.defaultValues?.disability : 'NONE'
  );
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    grade    : '',
    field    : '',
    gender   : '',
    birthDate: '',
  });

  async function onUploadImage(imageFile: File) {
    const imagePromise = await uploadImage!(imageFile);
    if (imagePromise?.CODE === 2042) setSelectedImage(imagePromise?.result);
  }

  const formik = useFormik<ICreateStudent>({
    enableReinitialize: true,
    initialValues: {
      state       : props?.defaultValues?.state        ? props?.defaultValues?.state        : '',
      lastName    : props?.defaultValues?.lastName     ? props?.defaultValues?.lastName     : '',
      firstName   : props?.defaultValues?.firstName    ? props?.defaultValues?.firstName    : '',
      sanadCode   : props?.defaultValues?.sanadCode    ? props?.defaultValues?.sanadCode    : '',
      nationalCode: props?.defaultValues?.nationalCode ? props?.defaultValues?.nationalCode : '',
    },
    validationSchema: Yup.object({
      lastName    : validations.yupValidations.lastName    ,
      firstName   : validations.yupValidations.firstName   ,
      nationalCode: validations.yupValidations.nationalCode,
    }),
    onSubmit: (values: ICreateStudent, { setSubmitting }) => {
      const formValues: ICreateStudent = {
        ...values,
        grade     : selectedGrade,
        field     : selectedField,
        gender    : selectedGender,
        avatar    : selectedImage?.link,
        birthDate : selectedBirthDate,
        disability,
      };
      if ( selectedGender ) {
        Promise.resolve(props.onSubmit(formValues)).catch(() => setSubmitting(false));
      }
    },
  });

  const submitHandler = (): void => {
    let dropDownErrorsList: { gender: string } = { gender: '' };
    if (!selectedGender) {dropDownErrorsList = {...dropDownErrorsList, gender: 'انتخاب جنسیت اجباری است'}}
    setDropDownErrors(dropDownErrorsList);
    formik.submitForm();
  };

  let gradeSchoolItems: IItem[] | ISchoolGrade[] = [];

  values.dropdownItems.GRADE.forEach((gradeItem) => {
    props.defaultValues.school?.grade.forEach((schoolGradeItem) => {
      if (gradeItem._id === schoolGradeItem.grade) {gradeSchoolItems = [...gradeSchoolItems, gradeItem]}
    });
  });
  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <form onSubmit={submitHandler} style={{ width: "100%" }}>
      <CustomView.Container className="create-form-content">
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="firstName"
              id="firstName"
              label="نام"
              value={formik.values.firstName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.firstName && formik.touched.firstName}
              errorText={formik.errors.firstName}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="lastName"
              id="lastName"
              label="نام خانوادگی"
              value={formik.values.lastName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.lastName && formik.touched.lastName}
              errorText={formik.errors.lastName}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">جنسیت</label>
            <CustomDropdownSearch
              items={values.dropdownItems.GENDER}
              itemName="name"
              placeHolder="جنسیت"
              defaultItem={selectedGender}
              onSelectItem={(event: any) => {
                setSelectedGender(event);
                setDropDownErrors({ ...dropDownErrors, gender: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.gender !== "" && dropDownErrors.gender}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">مقطع تحصیلی</label>
            <CustomDropdownSearch
              items={gradeSchoolItems}
              itemName="name"
              placeHolder="مقطع تحصیلی"
              defaultItem={selectedGrade}
              onSelectItem={(event: any) => {
                setSelectedField(undefined);
                setSelectedGrade(event);
              }}
            />
          </CustomView.Column>
        </CustomView.Row>
        {selectedGrade !== undefined &&
          (selectedGrade?._id === '10' ||
            selectedGrade?._id === '11' ||
            selectedGrade?._id === '12') && (
            <CustomView.Row className="form-row">
              <CustomView.Column medium={6} className="form-colum">
                {" "}
              </CustomView.Column>
              <CustomView.Column medium={6} className="form-colum dropdown">
                <label className="form-label">رشته‌ی تحصیلی</label>
                <CustomDropdownSearch
                  items={values.dropdownItems.FIELD}
                  itemName='name'
                  placeHolder='رشته‌ی تحصیلی'
                  defaultItem={selectedField}
                  onSelectItem={(event: any) => setSelectedField(event)}
                />
              </CustomView.Column>
            </CustomView.Row>
          )}
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <label className="form-label">تاریخ تولد</label>
            <CustomTimePiker
              defaultValue={selectedBirthDate}
              onChange={(event: string) => setSelectedBirthDate(event)}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="nationalCode"
              id="nationalCode"
              label="کد ملی"
              value={formik.values.nationalCode}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.nationalCode && formik.touched.nationalCode}
              errorText={formik.errors.nationalCode}
              maxLength={10}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="">
            <CustomCheckBox
              isChecked={disability !== 'NONE'}
              onChecked={(): void => disability === 'NONE' ? setDisability('OTHER') : setDisability('NONE')}
              label="دارای ناتوانی"
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="">
            <ImageUploader
              defaultImage={selectedImage}
              setImage={setSelectedImage}
              uploadImage={(event: any) => onUploadImage(event)}
            />
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => props.onBack(formik.values)}
              title="قبلی"
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={submitHandler}
              title="بعدی"
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

export default StudentInformation;
